import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Latest recorded Influenza / Pneumococcal dose dates for the patient, used to
// flag an overdue vaccine on the CDM review (Ref 31/33). Returns
// { influenzaLastDoseDate, pneumococcalLastDoseDate } (ISO dates or null).
export const useLatestCdmVaccineDoses = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["latestCdmVaccineDoses", patientId, tenantVal],
    queryFn: async () => {
      if (!patientId) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientimmunisation/latestcdmvaccinedoses/${patientId}`
      );

      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
  });
};
